import { COMPONENT_NAME_PREFIX } from '../../constants';

const elementName: keyof HTMLElementTagNameMap = `${COMPONENT_NAME_PREFIX}drawer`;

export const DRAWER_CONSTANTS = {
  elementName
};
